import {
    Container,
    Flex,
    Text,
    SimpleGrid,
    Box,
    Heading,
    Link,
    Stack
  } from '@chakra-ui/react';
  
  import { COLORS } from "../../../colors"
  import CursoModal from './cursoModal'

  
  import React from 'react';
  
  const cursos = [
    {
      name: 'PRIMARIA',
      image: '/primaria.jpg',
      link: '/cursos/primaria'
    },
    {
      name: 'ESO & BACHILLER',
      image: '/eso_bachiller.jpg',
      link: '/cursos/eso_bachiller'
    },
    {
      name: 'ADULTOS',
      image: '/adultos.jpg',
      link: '/cursos/adultos'
    },
    {
        name: 'INTENSIVO',
        image: '/intensivo.jpg',
        link: '/cursos/intensivo'
      },
    // Resto de cursos...
  ];
  
  const Cursos = () => {
    return (
      <Container maxW="5xl" py={10} px={6} >
        <Flex justifyContent="center" mb={8} flexDirection='column' textAlign='center'>
          <Heading textAlign={"center"} as="h2" size="xl" mt={6} mb={2} fontFamily={"Montserrat"}>
            Nuestros cursos 
          </Heading>
          <Text textAlign={"center"} fontSize={{ base: 'md', lg: 'lg' }} color={'gray.500'}>
            Nuestros cursos utilizan métodos interactivos y personalizados. Adaptamos nuestras clases a las necesidades de cada grupo, garantizando un aprendizaje efectivo y divertido en un ambiente de apoyo.
          </Text>
          <Stack direction={{ base: 'column', md: 'column' }} spacing={4} alignItems={'center'} mt={5}>
            <CursoModal />
          </Stack>
        </Flex>
        <SimpleGrid columns={{ base: 1, sm: 2, md: 4 }} placeItems="center" spacing={4} mt={12} mb={4}>
          {cursos.map((curso, index) => (
            <Link key={index} href={curso.link} _hover={{ textDecoration: 'none' }}>
              <Box mt={10} textAlign="center">
                <Box
                  height="100px"
                  width="200px"
                  backgroundImage={`url(${curso.image})`}
                  backgroundSize="cover"
                  backgroundPosition="center"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  borderRadius="md"
                  boxShadow="md"
                  filter="grayscale(75%)"
                  transition="all 0.3s ease"
                  _hover={{
                    filter: 'grayscale(0%)',
                    transform: 'scale(1.05)',
                  }}
                >
                  <Text
                    fontWeight="bold"
                    fontSize="lg"
                    fontFamily={"Montserrat"}
                    color="white"
                    p={2}
                    borderRadius="md"
                  >
                    {curso.name}
                  </Text>
                </Box>
              </Box>
            </Link>
          ))}
        </SimpleGrid>
      </Container>
    );
  };
  
  export default Cursos;
  